"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unpause = exports.pause = exports.track = exports.subscribeTracking = exports.cleanupTracking = void 0;
const eventBuffer = [];
let callback = undefined;
let isPause = false;
function cleanupTracking() {
    callback = undefined;
    isPause = false;
    eventBuffer.splice(0);
}
exports.cleanupTracking = cleanupTracking;
function subscribeTracking(eventCallback) {
    let currentEvent;
    callback = eventCallback;
    while ((currentEvent = eventBuffer.shift())) {
        callback(currentEvent);
    }
    return () => {
        callback = undefined;
    };
}
exports.subscribeTracking = subscribeTracking;
function track(event, options = {}) {
    // do not track any events on server
    if (typeof window === 'undefined')
        return;
    const { pausable = true } = options;
    const toPause = isPause && pausable;
    if (callback && !toPause) {
        callback(event);
    }
    else {
        eventBuffer.push(event);
    }
}
exports.track = track;
function pause() {
    isPause = true;
}
exports.pause = pause;
function unpause() {
    isPause = false;
    let event;
    while ((event = eventBuffer.shift())) {
        track(event);
    }
}
exports.unpause = unpause;
//# sourceMappingURL=index.js.map